import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import Modal from '../../../../../../components/Modal';
import TextInput from '../../../../../../components/TextInput';
import { Sheet } from '../AllergenModal/styled';
import { Field } from '../ProductEditModal/styled';
import Button from '../../../../../../components/Button';
import { HeaderSmall } from '../../../../../../components/Text';
import { formatPrice } from '@/utils/formatter';
import {
  ClickableTr,
  NoSearchResultContainer,
  SearchResultTable,
} from './styled';
import Checkbox from '../../../../../../components/Checkbox';
import { addProductsToCategory as addProductsToCategoryMutation } from '../../../../../../graphql/mutations';
import {
  brandCategoryProductsByStore as brandCategoryProductsByStoreQuery,
  productCategories as productCategoriesMutation,
} from '../../../../../../graphql/queries';
import i18n from '@/utils/i18n';

function AddProductModal({ onClose, allProductsForBrand, category, storeId }) {
  const [productSearchTerm, setProductSearchTerm] = useState('');
  const [searchResults, updateSearchResults] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState({});
  const [addProductsToCategory, { loading }] = useMutation(
    addProductsToCategoryMutation,
  );

  function onProductSearchTermChange(e) {
    const searchTermInput = e.target.value;
    setProductSearchTerm(searchTermInput);
    doSearch(searchTermInput);
  }

  function doSearch(productSearchTermInput) {
    const productSearchTermInputLowercase =
      productSearchTermInput.toLowerCase();
    const filteredSearchResults = allProductsForBrand.filter(
      (product) =>
        product.id.toLowerCase().includes(productSearchTermInputLowercase) ||
        product.name.toLowerCase().includes(productSearchTermInputLowercase),
    );
    updateSearchResults(filteredSearchResults);
  }

  function toggleProductSelection(product) {
    const { id } = product;
    if (typeof selectedProducts[id] === 'object') {
      setSelectedProducts({ ...selectedProducts, [id]: undefined });
    } else {
      setSelectedProducts({ ...selectedProducts, [id]: product });
    }
  }

  function handleSave() {
    const selectedProductKeys = Object.keys(selectedProducts).filter(
      (key) => !!key,
    );
    addProductsToCategory({
      variables: { category_id: category.id, product_ids: selectedProductKeys },
      onError: (err) => {
        // eslint-disable-next-line no-console
        console.log(err);
        // eslint-disable-next-line no-alert
        alert(err);
      },
      refetchQueries: [
        {
          query: brandCategoryProductsByStoreQuery,
          variables: {
            store_id: storeId,
          },
        },
        {
          query: productCategoriesMutation,
          variables: {
            id: storeId,
            filter: 'ALL',
          },
        },
      ],
      update: () => {
        onClose();
      },
    });
  }

  const selectedProductCounts = Object.keys(selectedProducts).filter(
    (key) => selectedProducts[key],
  ).length;

  return (
    <Modal onClose={onClose}>
      <Sheet>
        <Button
          disabled={selectedProductCounts === 0}
          onClick={handleSave}
          loading={loading}
        >
          {`Add (${selectedProductCounts}) products`}
        </Button>
        <br />
        <HeaderSmall>Search for Product</HeaderSmall>
        <Field>
          <TextInput
            name="product-search"
            placeholder={i18n.t('Common:productKeywordPlaceholder')}
            onChange={onProductSearchTermChange}
            value={productSearchTerm}
          />
        </Field>
        <SearchResultTable>
          <thead>
            <tr>
              <th>#</th>
              <th>product name</th>
              <th>price</th>
            </tr>
          </thead>
          <tbody>
            {searchResults.map((product, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <ClickableTr
                key={i}
                onClick={() => toggleProductSelection(product)}
              >
                <td width={25}>
                  <Checkbox
                    checked={typeof selectedProducts[product.id] === 'object'}
                  />
                </td>
                <td title={product.id}>{product.name}</td>
                <td>{formatPrice(product.price)}</td>
              </ClickableTr>
            ))}
          </tbody>
        </SearchResultTable>
        {searchResults.length === 0 && (
          <NoSearchResultContainer>No products found</NoSearchResultContainer>
        )}
      </Sheet>
    </Modal>
  );
}

AddProductModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  allProductsForBrand: PropTypes.arrayOf(PropTypes.object).isRequired,
  category: PropTypes.object.isRequired,
  storeId: PropTypes.string.isRequired,
};

export default AddProductModal;
